function normalizeManifestFiles(manifest) {
  const files = Array.isArray(manifest)
    ? manifest
    : Array.isArray(manifest?.files)
      ? manifest.files
      : [];

  return files
    .filter((file) => file && typeof file === "object")
    .map((file) => ({
      label: String(file.label ?? file.name ?? file.path ?? "").trim(),
      path: String(file.path ?? "").trim(),
    }))
    .filter((file) => file.label && file.path);
}

export async function loadManifest(selectEl) {
  const res = await fetch("data/manifest.json", { cache: "no-store" });

  if (!res.ok) {
    throw new Error(`Manifest konnte nicht geladen werden: ${res.status}`);
  }

  const manifest = await res.json();
  const files = normalizeManifestFiles(manifest);

  if (!files.length) {
    throw new Error("Manifest enthaelt keine gueltigen Online-Datenbanken.");
  }

  selectEl.innerHTML = '<option value="">Online JSON waehlen</option>';

  for (const file of files) {
    const opt = document.createElement("option");
    opt.value = file.path;
    opt.textContent = file.label;
    selectEl.appendChild(opt);
  }
}

export async function loadOnlineJson(path) {
  const res = await fetch(path, { cache: "no-store" });

  if (!res.ok) {
    throw new Error(`JSON konnte nicht geladen werden: ${res.status}`);
  }

  return await res.json();
}
